const iyfaoGP = {

    "T01":140,
    "T02":140,
    "T03":140,
    "T04":260,
    "T05":260,
    "T06":380,

     "P01":140,
    "P02":140,
    "P03":140,
    "P04":260,
    "P05":260,
    "P06":380,

     "D01":140,
    "D02":140,
    "D03":140,
    "D04":260,
    "D05":260,
    "D06":380,
}

export default iyfaoGP;